import "core-js/stable";

// manage bg images
const randomNumber = Math.floor(Math.random() * 3) + 1;
const bgClassname = 'entrance-' + randomNumber;

const entrance = document.getElementById('entrance');
entrance.classList.add(bgClassname);

const signupIsDefault = !document.getElementById('view-signup').classList.contains('hidden');
if (signupIsDefault) {
  $('#email-address').focus();
} else {
  $('#login-email').focus();
}

class View {
  constructor(viewName) {

    const debug = false;

    if (debug) {
      console.log('[View.constructor] viewName=' + viewName);
    }
    this.viewName = viewName;
  }
  static displayView(viewName, noRefresh, noPushState) {

    const debug = false
    const self = this

    if (typeof viewName !== 'undefined') {
      this.viewName = viewName;
    }
    if (typeof noRefresh === 'undefined') {
      noRefresh = false;
    }
    if (typeof noPushState === 'undefined') {
      noPushState = false;
    }

    if (debug) {
      console.log('[View.displayView] function called');
      console.log('[View.displayView] viewName='+viewName);
      console.log('[View.displayView] noRefresh='+noRefresh);
      console.log('[View.displayView] noPushState='+noPushState);
    }

    // if (CLIC_ACTIF) {
    //   if (debug) {
    //     console.log('[View.displayView] CLIC_ACTIF = true');
    //   }
    //   return false;
    // } else {
    //   CLIC_ACTIF = true;
    // }

    // if (!noPushState) {
    //   history.pushState({view: self.viewName}, 'Mon accès', 'mon-acces')
    //   if (debug) console.log('[View.displayView] pushState ' + self.viewName)
    // }

    $('.view').addClass('hidden');
    $('#view-' + self.viewName).removeClass('hidden');
  }
}

$('.link').on('click', function(e) {
  e.preventDefault();
  const debug = false;
  if (debug) {
    console.log('[EVENT click ON .link]');
  }
  let link = $(this).attr('data-link');
  if (debug) {
    console.log('[EVENT click ON .link] link=' + link);
  }
  View.displayView(link);
});

  // as soon as this file is loaded, connect automatically,
  // var socket = io.connect();

  // function displayError(errorMessage, element) {
  //   element.removeClass('hidden');
  //   if (typeof errorMessages[errorMessage] !== 'undefined') {
  //     element.html(errorMessages[errorMessage]);
  //   } else {
  //     element.html(errorMessage);
  //   }
  //   $('body').scrollTo('.container', 400, {offset: {top: -300} });
  // }

  // function displayErrorSocial(errorElement) {
  //   // display error social
  //   if (typeof err_social !== 'undefined' && err_social) {
  //     if (err_social == 1) { displayError('err_social_denied', errorElement); }
  //     if (err_social == 2) { displayError('err_social_email', errorElement); }
  //     if (err_social == 3) { displayError('err_social_verified', errorElement); }
  //   }
  // }

  // displayErrorSocial($('#signinError'));

  // $('#createAccountSend').bind('click', function() {
  //   $('#createAccountLoader').removeClass('hidden');
  //   var email        = $('#createAccountEmail').val();
  //   var password     = $('#createAccountPassword').val();
  //   var errorElement = $('#createAccountError');
  //   if (! validator.isEmail(email)) { // Email is not ok
  //       displayError('invalidEmail', errorElement);
  //       $('#createAccountLoader').addClass('hidden');
  //   } else if (password.length < 6 ) { // Password too short
  //       displayError('pwdTooShort', errorElement);
  //       $('#createAccountLoader').addClass('hidden');
  //   } else if (password.length >= 20 ) { // Password too long
  //       displayError('pwdTooLong', errorElement);
  //       $('#createAccountLoader').addClass('hidden');
  //   } else {

  //           io.socket.post("/createAccount", {email: email, password: password, _csrf: CSRF_TOKEN}, function (response) {

  //               if (response.status != 'ok') {
  //                   if (typeof response.error === 'undefined'){
  //                       displayError('err_system', errorElement);
  //                   } else {
  //                       displayError(response.error.label, errorElement);
  //                   }
  //                   $('#createAccountLoader').addClass('hidden');

  //               } else {
  //                   window.location.href = '/characters';
  //               }

  //           });
  //       }
  //   });

    // $('#signinSend').bind('click', function() {

    //     var debug = false;

    //     $('#signinLoader').removeClass('hidden');

    //     var email    = $('#signinEmail').val();
    //     var password = $('#signinPassword').val();

    //     var errorElement = $('#signinError');

    //     if (! validator.isEmail(email)) { // Email is not ok
    //         displayError('err_id_auth', errorElement);
    //         $('#signinLoader').addClass('hidden');
    //     } else if (password.length < 6 ) { // Password too short
    //         displayError('err_id_auth', errorElement);
    //         $('#signinLoader').addClass('hidden');
    //     } else if (password.length >= 20 ) { // Password too long
    //         displayError('err_id_auth', errorElement);
    //         $('#signinLoader').addClass('hidden');
    //     } else {

    //         var rememberEmail = $('#rememberEmail').is(':checked');
    //         if (debug) console.log('Send signin request');
    //         io.socket.post("/signin", {email: email, password: password, rememberEmail: rememberEmail, _csrf: CSRF_TOKEN}, function (response) {

    //             if (debug) console.log('Signin request done');
    //             if (debug) console.log(response);

    //             if (response.status != 'ok') {
    //                 if (typeof response.error === 'undefined') {
    //                     displayError('err_system', errorElement);
    //                 } else {
    //                     displayError(response.error.label, errorElement);
    //                 }
    //                 $('#signinLoader').addClass('hidden');

    //             } else {
    //                 window.location.href = '/characters';
    //             }

    //         });
    //     }
    // });

    // $('#forgottenPswdSend').bind('click', function() {

    //     $('#forgottenPswdLoader').removeClass('hidden');

    //     var email        = $('#forgottenPswdEmail').val();
    //     $('#forgottenPswdEmail').val('');
    //     var errorElement = $('#forgottenPswdError');

    //     if (! validator.isEmail(email)) { // Email is not ok
    //         displayError('invalidEmail', errorElement);
    //         $('#forgottenPswdLoader').addClass('hidden');
    //     } else {

    //         io.socket.post("/resetPassword", {email: email, _csrf: CSRF_TOKEN}, function (response) {

    //             if (response.status != 'ok') {
    //                 if (typeof response.error === 'undefined') {

    //                     displayError('err_system', errorElement);
    //                 } else {
    //                     displayError(response.error.label, errorElement);
    //                 }
    //                 $('#forgottenPswdLoader').addClass('hidden');

    //             } else {
    //                 $('#forgottenPswdSuccess').removeClass('hidden');
    //                 $('#forgottenPswdLoader').addClass('hidden');
    //             }
    //         });
    //     }
    // });

    // // Simulate form submission by pressing the ENTER touch
    // var focused = '';

    // $('#createAccountEmail, #createAccountPassword, #signinEmail, #signinPassword').bind('focus', function() {
    //     focused = $(this).attr('id');
    // });

    // $('#createAccountEmail, #createAccountPassword, #signinEmail, #signinPassword').bind('blur', function() {
    //     focused = '';
    // });

    // $('#createAccountEmail, #createAccountPassword, #signinEmail, #signinPassword').bind('keyup', function(e) {

    //     // ENTER
    //     if (e.keyCode == 13) {
    //         switch (focused) {
    //             case 'createAccountEmail':
    //             case 'createAccountPassword':
    //                 $('#createAccountSend').trigger('click');
    //                 break;

    //             case 'signinEmail':
    //             case 'signinPassword':
    //                 $('#signinSend').trigger('click');
    //                 break;
    //         }
    //     }
    // });

// })(window.io);


// $(document).ready(function() {

//     FastClick.attach(document.body);

//     location.href = location.href.replace(/#signin/g, '').replace(/#createAccount/g, '').replace(/#forgottenPswd/g, '')+ '#signin';

//     var tempParam = location.href.split('#');

//     switch (tempParam[1]) {
//         case 'signin':
//             $('#btSignin').trigger('click');
//             break;
//         case 'createAccount':
//             $('#btCreateAccount').trigger('click');
//             break;
//         case 'forgottenPswd':
//             $('#btForgottenPswd').trigger('click');
//             break;
//         default:
//             $('#btSignin').trigger('click');
//             break;
//     }
// });

    // window.onpopstate = function(event) {

    //     if (typeof event.explicitOriginalTarget.baseURI === 'undefined') {

    //         var tempParam = location.href.split('#');

    //         switch (tempParam[1]) {
    //             case 'signin':
    //                 $('.linkSignin').trigger('click');
    //                 break;
    //             case 'createAccount':
    //                 $('#btCreateAccount').trigger('click');
    //                 break;
    //             case 'forgottenPswd':
    //                 $('#btForgottenPswd').trigger('click');
    //                 break;
    //             default:
    //                 $('.linkSignin').trigger('click');
    //                 break;
    //         }


    //     }

    // };

// function showFormLogin(element) {
//     hideFormLogin();
//     element.removeClass('hidden');
// }

// function hideFormLogin() {
//     $('.formLogin, #forgottenPswdSuccess, .error').addClass('hidden');
// }

// $('#btSignin, .linkSignin').bind('click', function() {
//     showFormLogin($('#signinFormLogin'));
//     location.href = location.href.replace(/#signin/g, '').replace(/#createAccount/g, '').replace(/#forgottenPswd/g, '')+ '#signin';
// });

// $('#btCreateAccount, #linkCreateAccount').bind('click', function() {
//     showFormLogin($('#createAccountFormLogin'));
//     location.href = location.href.replace(/#signin/g, '').replace(/#createAccount/g, '').replace(/#forgottenPswd/g, '')+ '#createAccount';
// });

// $('#btForgottenPswd').bind('click', function() {
//     showFormLogin($('#forgottenPswdFormLogin'));
//     location.href = location.href.replace(/#signin/g, '').replace(/#createAccount/g, '').replace(/#forgottenPswd/g, '')+ '#forgottenPswd';
// });
